module.exports = __webpack_public_path__ + "img/12.f980e517.svg";